var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.185,3.185l11.63,11.63M3.185,14.815l11.63,-11.63","stroke":_vm.color,"stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }